import { useEffect, useRef, useState } from "react";
import { Drawer, Input } from "antd";
import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";
import { Link, useNavigate } from "react-router-dom";
import AppRoutes from "../../common/routes";

const RequestTransactionCode = (props) => {
  const navigate = useNavigate();
  const otpBoxReference = useRef([]);
  const [inputBoxCount] = useState(props.inputCount ? props.inputCount : 5);
  const [currIndex, setCurrIndex] = useState(0);
  const [otp, setOtp] = useState(new Array(inputBoxCount).fill(""));

  const handlePinSetupRedirect = () => {
    const currentPath = window.location.pathname + window.location.search;
    sessionStorage.setItem("redirectAfterPinSetup", currentPath);
  };

  useEffect(() => {
    if (!props.openDrawer) {
      setOtp(new Array(inputBoxCount).fill(""));
      setCurrIndex(0);
    }
  }, [props.openDrawer, inputBoxCount]);

  const handleOTPChange = (value) => {
    const newArr = [...otp];
    newArr[currIndex] = value;
    setOtp(newArr);

    if (value && currIndex < inputBoxCount - 1) {
      otpBoxReference.current[currIndex + 1].focus();
      setCurrIndex(currIndex + 1);
    } else if (value && currIndex === inputBoxCount - 1) {
      const completeOtp = newArr.join("");
      props.stateFunc?.(completeOtp);
      props.actionFunction?.(completeOtp);
      props.closeDrawer?.();
      setOtp(new Array(inputBoxCount).fill(""));
      setCurrIndex(0);
    }
  };

  const onKeyPressInput = (button) => {
    if (button === "{bksp}") {
      const newArr = [...otp];
      newArr[currIndex] = "";
      setOtp(newArr);

      if (currIndex >= 1) {
        otpBoxReference.current[currIndex - 1].focus();
        setCurrIndex(currIndex - 1);
      } else {
        otpBoxReference.current[0].focus();
        setCurrIndex(0);
      }
    } else {
      handleOTPChange(button);
    }
  };

  const handleChange = (value, index) => {
    if (!/^\d*$/.test(value)) return;

    const newArr = [...otp];
    newArr[index] = value;
    setOtp(newArr);
    setCurrIndex(index);

    if (value && index < inputBoxCount - 1) {
      otpBoxReference.current[index + 1].focus();
      setCurrIndex(index + 1);
    } else if (value && index === inputBoxCount - 1) {
      const completeOtp = newArr.join("");
      props.stateFunc?.(completeOtp);
      props.actionFunction?.(completeOtp);
      props.closeDrawer?.();
      setOtp(new Array(inputBoxCount).fill(""));
      setCurrIndex(0);
    }
  };

  const handleBackspaceAndEnter = (e, index) => {
    if (e.key === "Backspace" && !e.target.value && index > 0) {
      setCurrIndex(index - 1);
      otpBoxReference.current[index - 1].focus();
    }
    if (e.key === "Enter" && e.target.value && index < inputBoxCount - 1) {
      setCurrIndex(index + 1);
      otpBoxReference.current[index + 1].focus();
    }
  };

  return (
    <div className="otp-input-box">
      <Drawer
        open={props.openDrawer}
        className="trans-code"
        onClose={props.closeDrawer}
        footer={null}
        title=""
        placement="bottom"
        closable={false}
        key="bottom"
      >
        <div className="overflow-auto h-full">
          {props.children}

          {!props.transChildrenPresent && (
            <div className="center">
              <h3>Enter Transaction PIN</h3>
            </div>
          )}

          <div className="modal-input-box mt_3">
            <div className="otp-inner-div">
              {otp.map((digit, index) => (
                <Input.Password
                  key={index}
                  value={digit}
                  inputMode="numeric"
                  maxLength={1}
                  type="tel"
                  visibilityToggle={false}
                  onChange={(e) => handleChange(e.target.value, index)}
                  onKeyUp={(e) => handleBackspaceAndEnter(e, index)}
                  style={{ height: "5rem" }}
                  ref={(reference) =>
                    (otpBoxReference.current[index] = reference)
                  }
                  className=""
                />
              ))}
            </div>
            <div className="onscreen mt_3">
              <div className="numeric-cover">
                {!props.hasTransactionPin && (
                  <Link
                    to={AppRoutes.update_trans_pin}
                    onClick={handlePinSetupRedirect}
                  >
                    Update transaction code (PIN)
                  </Link>
                )}
              </div>
              {/* <Keyboard
                layout={{
                  default: ["1 2 3", "4 5 6", "7 8 9", " 0 {bksp}"],
                }}
                theme="hg-theme-default hg-layout-numeric numeric-theme"
                onKeyPress={onKeyPressInput}
                inputPattern="tel"
              /> */}
            </div>
          </div>
        </div>
      </Drawer>
    </div>
  );
};

export default RequestTransactionCode;
